<div class="chunk-copy-to-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        class="close-button"
        [mat-dialog-close]="null"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <div class="content-row">
      <div class="chunks-list">
        <h3 class="section-title">Selected chunks:</h3>
        <ul class="chunks-ul">
          @for (chunk of chunks; track chunk.stepId) {
            <li>{{ getChunkName(chunk) }}</li>
          }
        </ul>
      </div>
      <mat-form-field appearance="outline" class="workflow-select">
        <mat-label>Select workflow</mat-label>
        <mat-select (selectionChange)="selectNotebook($event)">
          @for (notebook of notebooks; track notebook.workflowId) {
            <mat-option [value]="notebook">
              {{ notebook.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    @if (data.cancelCaption) {
      <button class="cancel-button" [mat-dialog-close]="null">
        {{ data.cancelCaption }}
      </button>
    }
    @if (data.confirmCaption) {
      <button
        class="confirm-button"
        [mat-dialog-close]="{
          chunks,
          notebook: selectedNotebook,
        }"
      >
        {{ data.confirmCaption }}
      </button>
    }
  </div>
</div>
